
export const projects = [
  {
    title: "licence 1998",
    subtitle: "Licence appliquée en commerce international",
    description:
      "Comprendre l'importance de l'environement économique, social, politique et légal dans le management international",
  },
  {
    title: "DESA 2002",
    subtitle: "DESA en finance d'entreprise",
    description:
      "Savoir faire en matière de réglementation financière d'entreprise",
  },
  {
    title: "Doctorat marocain 2010",
    subtitle: "Doctorat marocain en Gestion des ressources humaines",
    description:
      "Approfondissement des connaissances en matière de ressources humaines et de psychologie de travail",
  },
  {
    title: "Doctorat français 2013",
    subtitle: "Doctorat français en psychologie sociale",
    description:
      "Approfondissement des connaissances en matière de psychologie de sociale",
  },
];

export const videos = [
   {
    title: "Ressources humaines Pr: ELLIOUA Hanane séance:1",
    subtitle: "Séance: 1 sur 10",
    description: "Comment preparer son CV",
    image: "./rh.jpg",
    link: "https://www.youtube.com/watch?v=ouT0NhTQQ-4",
  },
  {
    title: "Psychologie Sociale Pr: ELLIOUA Hanane",
    subtitle: "Séance: 1 sur 10",
    description: "Définition, concepts clés et contenu de la psychologie sociale",
    image: "./ps.jpg",
    link: "https://www.youtube.com/watch?v=3WJ4Q2zyj_8",
  },
];

export const articles=[
  {
    title: "REALITE DE LA COMMUNICATION INTERNE DANS LE CONTEXTE ORGANISATIONNEL: CAS D’UN ETABLISSEMENT UNIVERSITAIRE",
    link:"https://revues.imist.ma/index.php/jbe/article/view/14943",
  },
  {
    title:"ESSAI DE CONCEPTUALISATION DE LA COMMUNICATION INTERNE AU SEIN DES ORGANISATIONS",
    link: "https://revues.imist.ma/index.php/jbe/article/view/9181",
  },
  {
    title:"La performance manageriale du cadre dirigeant marocain: A la recherche du sens et la determination des facteurs qui impactent sa performance en entrprise",
    link: "https://revues.imist.ma/index.php/RMGE/article/view/6535",
  },
  {
    title:"L’intégration et les tactiques utilisées par les nouvelles recrues dans les entreprises marocaines.",
    link: "https://revues.imist.ma/index.php/REK/article/view/23611",
  },
]


// WEBPACK FOOTER //
// ./src/data.js